/* CANO — Concept D interactions. Cart drawer / variants live in cart.js & product.js. */
(function () {
  "use strict";

  /* ---------- Header: transparent over hero, solid after (solid by default if no hero) ---------- */
  var header = document.querySelector(".site-header");
  var hero = document.querySelector(".hero");
  if (header) {
    if (hero && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        header.classList.toggle("solid", !entries[0].isIntersecting);
      }, { rootMargin: "-70px 0px 0px 0px", threshold: 0 }).observe(hero);
    } else {
      header.classList.add("solid");
    }
  }

  /* ---------- Menu overlay ---------- */
  var menu = document.querySelector(".menu-overlay");
  var openBtn = document.querySelector(".menu-btn");
  if (menu && openBtn) {
    var setMenu = function (open) {
      menu.classList.toggle("open", open);
      document.body.classList.toggle("menu-open", open);
      openBtn.setAttribute("aria-expanded", open ? "true" : "false");
    };
    openBtn.addEventListener("click", function () { setMenu(true); });
    var closeBtn = menu.querySelector(".close");
    if (closeBtn) closeBtn.addEventListener("click", function () { setMenu(false); });
    menu.querySelectorAll("nav a, .menu-util a").forEach(function (a) {
      a.addEventListener("click", function () { setMenu(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && menu.classList.contains("open")) setMenu(false);
    });
  }

  /* ---------- Video sound toggle (per .film) ---------- */
  document.querySelectorAll(".film").forEach(function (film) {
    var vid = film.querySelector(".film-vid");
    var btn = film.querySelector(".mute-btn");
    if (!vid || !btn) return;
    btn.addEventListener("click", function () {
      vid.muted = !vid.muted;
      if (!vid.muted) { vid.play().catch(function () {}); }
      btn.textContent = vid.muted ? "Sound on" : "Sound off";
      btn.setAttribute("aria-pressed", String(!vid.muted));
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ("IntersectionObserver" in window) {
    var rObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); rObs.unobserve(e.target); }
      });
    }, { threshold: 0.2 });
    document.querySelectorAll(".reveal").forEach(function (el) { rObs.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- Accordions (PDP specs/shipping, FAQ) ---------- */
  document.querySelectorAll(".accordion__head").forEach(function (head) {
    head.addEventListener("click", function () {
      var item = head.closest(".accordion__item");
      if (!item) return;
      var body = item.querySelector(".accordion__body");
      var open = item.classList.toggle("is-open");
      head.setAttribute("aria-expanded", open ? "true" : "false");
      if (body) body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
    });
  });
  // pre-open any accordion marked is-open on load
  document.querySelectorAll(".accordion__item.is-open .accordion__body").forEach(function (body) {
    body.style.maxHeight = body.scrollHeight + "px";
  });

  /* ---------- Collection facet dropdowns ---------- */
  document.querySelectorAll(".facet__toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      var facet = toggle.closest(".facet");
      if (!facet) return;
      var isOpen = facet.classList.contains("is-open");
      document.querySelectorAll(".facet.is-open").forEach(function (f) { if (f !== facet) f.classList.remove("is-open"); });
      facet.classList.toggle("is-open", !isOpen);
      toggle.setAttribute("aria-expanded", !isOpen ? "true" : "false");
    });
  });
  document.addEventListener("click", function () {
    document.querySelectorAll(".facet.is-open").forEach(function (f) { f.classList.remove("is-open"); });
  });

  /* ---------- PDP gallery: thumbnails + arrows + swipe ---------- */
  document.querySelectorAll(".product__gallery").forEach(function (gallery) {
    var mainImg = gallery.querySelector("[data-gallery-main] img") || gallery.querySelector(".product__main-img img");
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll(".product__thumb[data-full]"));
    if (!mainImg || !thumbs.length) return;
    var idx = 0;
    function show(i) {
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      mainImg.removeAttribute("srcset");
      mainImg.src = t.getAttribute("data-full");
      thumbs.forEach(function (x) { x.setAttribute("aria-current", "false"); });
      t.setAttribute("aria-current", "true");
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { show(i); }); });
    var prev = gallery.querySelector("[data-gal-prev]");
    var next = gallery.querySelector("[data-gal-next]");
    if (prev) prev.addEventListener("click", function () { show(idx - 1); });
    if (next) next.addEventListener("click", function () { show(idx + 1); });
    // touch swipe on the main image
    var startX = null;
    var surface = gallery.querySelector(".product__main-img") || mainImg;
    surface.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
    surface.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
      startX = null;
    }, { passive: true });
  });

  /* ---------- Colorway / variant selection (self-contained; works on homepage + PDP) ---------- */
  function initVariants(form, product) {
    var idInput = form.querySelector("[data-variant-id]");
    var addBtn = form.querySelector("[data-add-btn]");
    var addLabel = form.querySelector("[data-add-label]");
    var pid = product.id;
    var S = (window.CANO && window.CANO.strings) || {};
    var fmt = (window.CANO && window.CANO.cart && window.CANO.cart.moneyFormat) || "${{amount}}";
    function money(c) { return fmt.replace(/\{\{\s*\w+\s*\}\}/g, function () { return (c / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }); }

    var sel = {};
    var seedId = idInput && idInput.value;
    var cur = product.variants.filter(function (v) { return String(v.id) === String(seedId); })[0] || product.variants[0];
    if (cur) (product.options || []).forEach(function (o, i) { sel[i + 1] = cur.options[i]; });

    function find() { return product.variants.filter(function (v) { return v.options.every(function (opt, i) { return opt === sel[i + 1]; }); })[0]; }
    function apply() {
      var v = find();
      if (!v) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = S.soldOut || "Unavailable"; return; }
      if (idInput) idInput.value = v.id;
      document.querySelectorAll('[data-price-main="' + pid + '"]').forEach(function (el) {
        el.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      });
      var inline = form.querySelector("[data-price-inline]");
      if (inline) inline.textContent = money(v.price);
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.innerHTML = v.available
        ? ((S.addToCart || "Add to cart") + ' — <span data-price-inline>' + money(v.price) + "</span>")
        : (S.soldOut || "Sold out");
      var vimg = (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) ||
                 (v.featured_image && (v.featured_image.src || v.featured_image));
      if (vimg && typeof vimg === "string") {
        var main = document.querySelector('[data-gallery-main="' + pid + '"] img');
        if (main) { main.removeAttribute("srcset"); main.src = vimg; }
      }
    }

    form.querySelectorAll("[data-option-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var pos = parseInt(btn.getAttribute("data-position"), 10);
        sel[pos] = btn.getAttribute("data-value");
        form.querySelectorAll('[data-option-value][data-position="' + pos + '"]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
        apply();
      });
    });
  }

  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var root = form.closest("[data-product-root]") || form;
    var jsonEl = root.querySelector("[data-product-json]");
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (typeof data === "string" && data) {
      // Liquid quirk: a product-picker setting serializes to its handle; fetch the real product
      fetch("/products/" + data + ".js")
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p && p.variants && p.variants.length) initVariants(form, p); })
        .catch(function () {});
    } else if (data && data.variants && data.variants.length) {
      initVariants(form, data);
    }
  });
})();
